import { render, staticRenderFns } from "./wallet-settings.vue?vue&type=template&id=5d083ef9"
import script from "./wallet-settings.vue?vue&type=script&lang=js"
export * from "./wallet-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports